'use client'

import { useState, useEffect } from 'react'
import { fetchMenuClient } from '@/app/lib/data'

export function useMenu() {
  const [menuData, setMenuData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    loadMenu()
  }, [])

  const loadMenu = async () => {
    try {
      setLoading(true)
      setError(null)
      const data = await fetchMenuClient()
      setMenuData(data)
    } catch (err) {
      console.error('Ошибка загрузки меню:', err)
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return {
    menuData,
    loading,
    error,
    loadMenu
  }
}
